import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { IPreRegistrationContextValue } from "../../shared/interfaces/PreRegistrationContextValue";


export interface IPreRegistrationContextSet {
  preRegValue: IPreRegistrationContextValue; 
  setPreRegValue: Dispatch<SetStateAction<IPreRegistrationContextValue>>;
}

// Create the context with an initial value
export const PreRegistrationContext = createContext<IPreRegistrationContextSet | undefined>(undefined);

export const usePreRegistrationContext = () => {
    const context = useContext(PreRegistrationContext);
    if (!context) {
      throw new Error('usePreRegistrationContext must be used within an PreRegistrationContextProvider');
    }
    return context;
  };


